export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8221.4ce77a30.jpg";